<kendo-dialog
	title="Document Agreement"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div class="kpa-offline-dialog-window">
		<div class="flex-table">
			<div class="flex-header">
				<div class="flex-column">Name</div>
				<div class="flex-column">Read Confirmation</div>
			</div>
			<div
				class="flex-body"
				*ngFor="let attachment of offlineAttachments">
				<div class="flex-column">
					<button

						class="offline-doc-download wrap-btn"
						kendoButton
						[title]="attachment.title"
						(click)="downloadFileByFileId(attachment)">
						{{ attachment.title }}
					</button>
				</div>
				<div class="flex-column">
					<div class="k-checkbox-wrap">
						<input
							[disabled]="!attachment.readConfirmationDisplay"
							#acceptAgreement
							type="checkbox"
							[(ngModel)]="attachment.readConfirmation"
							kendoCheckBox />
					</div>
				</div>
			</div>
		</div>
	</div>
	<kendo-dialog-actions [layout]="'end'">
		<button
			style="width: 30%"
			kendoButton
			[ngClass]="!isReadDocEnabled ? 'disabled-button' : 'primary-button'"
			[disabled]="!isReadDocEnabled"
			(click)="completeOfllineTraining()">
			Okay
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
